import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

export const apiError = (e, fallback = "Algo salió mal. Probá de nuevo.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return "Revisá los datos ingresados.";
  return fallback;
};
